// extracted by mini-css-extract-plugin
export var subtitle = "_8x-2";
export var title = "_8x-0";
export var titleNoWrap = "_8x-1";